<template>
  <div class="w-full pb-0 lg:pb-10 pt-10">
    <div
      class="gridClass flex justify-between flex-col-reverse lg:flex-row"
    >
      <div
        class="w-full lg:w-1/2 pb-0 flex flex-col lg:pe-10"
        :class="hasSpace ? 'justify-between' : 'justify-start'"
      >
        <div class="mt-6">
          <h1 class="text-center lg:text-start lg:inline text-primary-600">{{ details.title }}</h1>
          <template v-if="details?.subTitle">
            <span class="h1 hidden lg:inline">؛ </span>
            <span class="h1 block lg:inline text-center">{{ details?.subTitle }}</span>
          </template>
          <p class="text-justify text-body1-semibold mt-5">{{ details.desc }}</p>
        </div>
        <div
          v-if="details.firstButton || details.secondButton"
          class="flex mt-10 lg:mb-1 flex-col lg:flex-row *:mb-4 *:lg:mb-0 *:lg:w-[45%] justify-between"
        >
          <div v-if="details.firstButton">
            <ProductButton :buttonInfo="details.firstButton" />
          </div>
          <div v-if="details.secondButton">
            <ProductButton :buttonInfo="details.secondButton" />
          </div>
        </div>
      </div>
      <NuxtImg
        v-if="details.img"
        width="500"
        height="442"
        class="mx-auto rounded-xl"
        :class="details.imgClass"
        :src="details.img"
        :alt="details.title"
        sizes="200px md:500px"
        :preload="{ fetchPriority: 'high' }"
        fetchpriority="high"
        loading="eager"
      />
    </div>
  </div>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  details: Object,
  hasSpace: Boolean,
  isDark: Boolean,
});

const slots = useSlots();

const scrollTo = (id) => {
  const position = findPosition(document.getElementById(id));
  window.scroll(0, position[0] - 100);
};

const findPosition = (obj) => {
  var currenttop = 0;
  if (obj.offsetParent) {
    do {
      currenttop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [currenttop];
  }
};

const modalsStore = useModalsStore();

const showMainModal = () => {
  modalsStore.openModal('CTA');
};
</script>
